import { useLocation } from 'react-router-dom';
import { addListingStepsData } from '~addListing/utils/data';

const MobileSteps = () => {
  const pathName = useLocation().pathname;

  const getActiveStep = (step: string) => {
    return {
      isActive: pathName.includes(step),
      step: addListingStepsData.find((step) =>
        pathName.includes(`${step.url}`),
      ),
    };
  };

  return (
    <div className="flex flex-row gap-x">
      {addListingStepsData.map((step) => (
        <div
          key={step.id}
          className={`${(getActiveStep(`${step.title}`)?.step?.id ?? 0) > step.id ? 'bg-blue_light_1' : 'bg-blue_light_2'} h-[6px]  rounded-[12px] flex-1`}
        ></div>
      ))}
    </div>
  );
};

export default MobileSteps;
